<template>
  <span>
    {{ translateCommissionStatus() }}
  </span>
</template>

<script>
import { COMMISSION_STATUS } from '../constants';

export default {
  props: {
    value: {
      type: String,
      default: '',
      required: true,
    },
  },
  methods: {
    translateCommissionStatus() {
      return this.value ? COMMISSION_STATUS[this.value] : '';
    },
  },
};
</script>
